//Install
import React, { Component } from "react";
//Install
import propTypes from "prop-types";

//Element
class Copyright extends Component {
    //Element
    render() {
        //Element
        const { ID, Title } = this.props
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB e72m90" },
            //Element
            React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB e2m45d" },
                //Element
                Title
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
Copyright.propTypes = {
    ID: propTypes.string.isRequired,
    Title: propTypes.string.isRequired
}
//Element
export default Copyright;